// Limite de période des rapports/historiques (clients : 14 j par défaut, admin : illimité)
export const limitDays = (user) => (user?.report_limit_days ?? null);

export const clampFrom = (user, from) => {
  const lim = limitDays(user);
  if (!lim || !from) return {};
  const minDay = new Date(from); minDay.setDate(minDay.getDate() - (lim - 1));
  const maxDay = new Date(from); maxDay.setDate(maxDay.getDate() + (lim - 1));
  return { before: minDay, after: maxDay };
};

export const limitText = (user) => {
  const lim = limitDays(user);
  return lim ? `Période limitée à ${lim} jours` : "";
};
